import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import UploadedFilesTable from './uploadedfilestable';
import UploadedFileCard from './uploadfilecard';
import { useSelector } from 'react-redux';
import styles from '../dashboardstyles';
import { DropzoneDialog } from 'mui-file-dropzone';

const FileUpload = () => {
  const [openFileUpload, setOpenFileUpload] = React.useState(false);
  const st = useSelector((state) => state.rootReducer);
  return (
    <Box>
      <Box
        sx={{
          mt: 3,
          ml: 2,
          display: 'flex',
          flexDirection: 'row',
          adjustItems: 'center',
          border: 0,
          justifyContent: 'space-between'
        }}>
        <Typography variant="h6">
          Case Info for{' '}
          {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
          {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
          (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'})
        </Typography>
      </Box>
      <Typography style={styles.titleText}>Files you uploaded</Typography>
      <Box
        sx={{
          ml: 5,
          mr: 5
        }}>
        <Typography style={styles.helperText}>
          Supported file types: PNG, BMP, JPEG, JPG, GIF, PDF, RTF, DOC, DOCX, TXT, XLS, XLSX, XML,
          TIF, TIFF. The maximum file size is 4 MB.
        </Typography>
        <Typography style={styles.helperText}>
          If you have large digital medical imaging files (DICOM imaging e.g. X-rays, MRIs, CTs,
          PETs, ultrasounds, echocardiograms, etc.), use the link:
          <a
            href="https://bch.ambrahealth.com/share/bostonchildrenshospital"
            target="_blank"
            rel="noopener noreferrer">
            https://bch.ambrahealth.com/share/bostonchildrenshospital
          </a>
        </Typography>
      </Box>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'right',
          mt: 5,
          mr: 5,
          border: 0
        }}>
        <Button
          size="large"
          variant="contained"
          sx={{ mb: 5 }}
          onClick={() => setOpenFileUpload(true)}>
          Upload file
        </Button>
      </Box>
      <DropzoneDialog
        acceptedFiles={[
          'image/*, application/pdf, .rtf, .doc, .docx, .txt, .xls, .xlsx, .xml, .tif, .tiff,'
        ]}
        cancelButtonText={'cancel'}
        submitButtonText={'submit'}
        maxFileSize={4000000}
        open={openFileUpload}
        onClose={() => setOpenFileUpload(false)}
        onSave={(files) => {
          console.log('Files:', files);
          setOpenFileUpload(false);
        }}
        showPreviews={true}
        showFileNamesInPreview={true}
      />
      <Box sx={{ mr: 5, ml: 2 }}>
        <UploadedFilesTable />
      </Box>
      <Box sx={{ mr: 5, ml: 2, mt: 5 }}>
        <UploadedFileCard />
      </Box>
    </Box>
  );
};

export default FileUpload;
